import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _TimeProgressLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5.282 5.282A9.5 9.5 0 1 0 12 2.5M12 12 7 7M12 2.5V5M21 12h-2M12 19v2M5 12H3" })));
}
const TimeProgressLight = forwardRef(_TimeProgressLight);
export { TimeProgressLight };
